/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlHyperlink } from './ControlHyperlink';
import {
    ControlHyperlinkFromJSON,
    ControlHyperlinkFromJSONTyped,
    ControlHyperlinkToJSON,
} from './ControlHyperlink';

/**
 * 
 * @export
 * @interface ControlUpdateZeroDayAlertRequest
 */
export interface ControlUpdateZeroDayAlertRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateZeroDayAlertRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateZeroDayAlertRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateZeroDayAlertRequest
     */
    vendor_name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateZeroDayAlertRequest
     */
    cve?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateZeroDayAlertRequest
     */
    short_risk_description: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateZeroDayAlertRequest
     */
    long_risk_description: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateZeroDayAlertRequest
     */
    how_to_resolve: string;
    /**
     * 
     * @type {Array<ControlHyperlink>}
     * @memberof ControlUpdateZeroDayAlertRequest
     */
    references: Array<ControlHyperlink>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlUpdateZeroDayAlertRequest
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlUpdateZeroDayAlertRequest
     */
    escalated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateZeroDayAlertRequest
     */
    first_detected_date?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateZeroDayAlertRequest
     */
    version_message?: string;
}

/**
 * Check if a given object implements the ControlUpdateZeroDayAlertRequest interface.
 */
export function instanceOfControlUpdateZeroDayAlertRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "vendor_name" in value;
    isInstance = isInstance && "short_risk_description" in value;
    isInstance = isInstance && "long_risk_description" in value;
    isInstance = isInstance && "how_to_resolve" in value;
    isInstance = isInstance && "references" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function ControlUpdateZeroDayAlertRequestFromJSON(json: any): ControlUpdateZeroDayAlertRequest {
    return ControlUpdateZeroDayAlertRequestFromJSONTyped(json, false);
}

export function ControlUpdateZeroDayAlertRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUpdateZeroDayAlertRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'title': json['title'],
        'vendor_name': json['vendor_name'],
        'cve': !exists(json, 'cve') ? undefined : json['cve'],
        'short_risk_description': json['short_risk_description'],
        'long_risk_description': json['long_risk_description'],
        'how_to_resolve': json['how_to_resolve'],
        'references': ((json['references'] as Array<any>).map(ControlHyperlinkFromJSON)),
        'active': json['active'],
        'escalated': !exists(json, 'escalated') ? undefined : json['escalated'],
        'first_detected_date': !exists(json, 'first_detected_date') ? undefined : json['first_detected_date'],
        'version_message': !exists(json, 'version_message') ? undefined : json['version_message'],
    };
}

export function ControlUpdateZeroDayAlertRequestToJSON(value?: ControlUpdateZeroDayAlertRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'title': value.title,
        'vendor_name': value.vendor_name,
        'cve': value.cve,
        'short_risk_description': value.short_risk_description,
        'long_risk_description': value.long_risk_description,
        'how_to_resolve': value.how_to_resolve,
        'references': ((value.references as Array<any>).map(ControlHyperlinkToJSON)),
        'active': value.active,
        'escalated': value.escalated,
        'first_detected_date': value.first_detected_date,
        'version_message': value.version_message,
    };
}

